import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from 'react-apollo';
import Header from '../header/Header';
import Analytics from './Analytics';
import { NUMERIC_VALUE } from '../../../utils';
import { GET_ADMIN_ANALYTICS } from '../../../graphql-client/queries';


function AnalyticsContainer() {
  const location = useLocation();
  const headerRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);

  const [getAnalyticsList, { loading: analyticsDataLoading, data: analyticsData, refetch: refreshList }] = useLazyQuery(
    GET_ADMIN_ANALYTICS,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    getAnalyticsList({ variables: { page: 1, limit: NUMERIC_VALUE.FIVE } });
  }, []);

  const infiniteScroll = (page, limit) => {
    setCurrentPage(page);
    refreshList({
      page,
      limit,
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <Header ref={headerRef} pathName={location.pathname} />
        <Analytics
          analyticsDataLoading={analyticsDataLoading}
          analyticsData={analyticsData && analyticsData.offerAnalytics}
          infiniteScroll={infiniteScroll}
          currentPage={currentPage}
          setTotalCount={(count) => {
            headerRef.current.setTotalCount(count);
          }}
        />
      </div>
    </>
  );
}
export default AnalyticsContainer;
